import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import setNullEmptyValues from 'common/util/setNullEmptyValues';

import {
  SR_API_ACTION_APARTMENT_SPECIAL_DEAL_UPSERT,
} from 'api/actionTypes';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrFormikField, {
  SR_FIELD_THEME_ADMIN,
} from 'client/components/SrFormikField';

import postWithState from 'client/actions/postWithState';

function getApartmentSpecialDealFormFields({ floorPlans } = {}) {
  return [
    {
      id: 'apartmentId',
      type: 'hidden',
    },
    {
      id: 'headline',
      type: 'short_text',
      title: 'headline',
      validations: ['required'],
    },
    {
      id: 'terms',
      type: 'short_text',
      title: 'terms',
      validations: ['required'],
    },
    {
      id: 'description',
      type: 'long_text',
      title: 'Description',
    },
    {
      id: 'emoji',
      type: 'short_text',
      title: 'emoji',
    },
    {
      id: 'leadOutreachText',
      type: 'short_text',
      title: 'rentlinx lead outreach text',
      validations: ['required'],
    },
    {
      id: 'floorPlanId',
      title: 'choose floorplan',
      type: 'select',
      properties: {
        enableResetOption: true,
        choices: (floorPlans || []).map(({ id, displayName }) => ({
          label: displayName,
          value: id,
        })),
      },
    },
    {
      id: 'applicableApartmentUnits',
      type: 'long_text',
      title: 'specific units assigned',
      properties: {
        placeholder: '["204", "205"]',
      },
      validations: ['stringifiedArray'],
    },
    {
      id: 'endDate',
      type: 'date_picker',
      title: 'end date',
      properties: {
        placeholder: 'MM/DD/YYYY',
      },
    },
  ];
}

class SrApartmentSpecialDealModal extends Component {
  static propTypes = {
    apartmentSpecialDeal: PropTypes.object.isRequired,
    floorPlans: PropTypes.array,
    onClose: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  _onSubmitForm = (formValues) => {
    const { apartmentSpecialDeal, onChange, dispatch } = this.props;
    const payload = {
      id: apartmentSpecialDeal.id,
      ...setNullEmptyValues(formValues),
    };

    payload.applicableApartmentUnits = payload.applicableApartmentUnits
      ? JSON.parse(payload.applicableApartmentUnits).map((unit) => `${unit}`)
      : [];

    payload.floorPlanId = payload.floorPlanId
      ? parseInt(payload.floorPlanId, 10)
      : null;

    payload.endDate = payload.endDate
      ? momentWithAustinTimezone(payload.endDate).endOf('day').toISOString()
      : null;

    dispatch(postWithState, {
      action: SR_API_ACTION_APARTMENT_SPECIAL_DEAL_UPSERT,
      payload,
    }).then(onChange);
  }

  render() {
    const { apartmentSpecialDeal, floorPlans, onClose } = this.props;
    const apartmentSpecialDealFormFields = getApartmentSpecialDealFormFields({
      floorPlans,
    });

    return (
      <SrDarkModal onClose={onClose}>
        <SrModalContent style={{ maxWidth: 440, height: '94vh', marginTop: 4 }}>
          <SrFlex justify='center'>
            <SrText size='2xl' align='center' font='whitney-sc'>
              special deal
            </SrText>
          </SrFlex>
          <SrBox marginTop={20}>
            <Formik
              initialValues={createInitialValues({
                formFields: apartmentSpecialDealFormFields,
                defaultValues: {
                  ...apartmentSpecialDeal,
                  applicableApartmentUnits: Array.isArray(apartmentSpecialDeal.applicableApartmentUnits)
                    && apartmentSpecialDeal.applicableApartmentUnits.length
                    ? JSON.stringify(apartmentSpecialDeal.applicableApartmentUnits)
                    : null,
                },
              })}
              validate={createFormValidationFn(apartmentSpecialDealFormFields)}
              onSubmit={this._onSubmitForm}
              render={(formikBag) => {
                return (
                  <Form autoComplete='off'>
                    {apartmentSpecialDealFormFields.map((formField) => (
                      <SrFormikField
                        key={formField.id}
                        formField={formField}
                        formikBag={formikBag}
                        className={SR_FIELD_THEME_ADMIN}
                      />
                    ))}
                    <SrBox marginTop={20}>
                      <ButtonDeprecated
                        type='submit'
                        disabled={!formikBag.isValid}
                      >
                        {apartmentSpecialDeal.id ? 'update' : 'create'}
                      </ButtonDeprecated>
                    </SrBox>
                  </Form>
                );
              }}
            />
          </SrBox>
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrApartmentSpecialDealModal.displayName = 'SrApartmentSpecialDealModal';

export default SrApartmentSpecialDealModal;
